export { MyParcelsLayout } from './MyParcelsLayout';
